import { render, staticRenderFns } from "./Machines.vue?vue&type=template&id=0b240f2c&scoped=true&"
import script from "./Machines.vue?vue&type=script&lang=js&"
export * from "./Machines.vue?vue&type=script&lang=js&"
import style0 from "./Machines.vue?vue&type=style&index=0&id=0b240f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b240f2c",
  null
  
)

export default component.exports